var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1875 5.625C2.1875 5.10723 2.60723 4.6875 3.125 4.6875C3.64277 4.6875 4.0625 5.10723 4.0625 5.625C4.0625 6.14277 3.64277 6.5625 3.125 6.5625C2.60723 6.5625 2.1875 6.14277 2.1875 5.625ZM6.25 5.625C6.25 5.27982 6.52982 5 6.875 5H16.875C17.2202 5 17.5 5.27982 17.5 5.625C17.5 5.97018 17.2202 6.25 16.875 6.25H6.875C6.52982 6.25 6.25 5.97018 6.25 5.625ZM2.1875 10C2.1875 9.48223 2.60723 9.0625 3.125 9.0625C3.64277 9.0625 4.0625 9.48223 4.0625 10C4.0625 10.5178 3.64277 10.9375 3.125 10.9375C2.60723 10.9375 2.1875 10.5178 2.1875 10ZM6.25 10C6.25 9.65482 6.52982 9.375 6.875 9.375H16.875C17.2202 9.375 17.5 9.65482 17.5 10C17.5 10.3452 17.2202 10.625 16.875 10.625H6.875C6.52982 10.625 6.25 10.3452 6.25 10ZM2.1875 14.375C2.1875 13.8572 2.60723 13.4375 3.125 13.4375C3.64277 13.4375 4.0625 13.8572 4.0625 14.375C4.0625 14.8928 3.64277 15.3125 3.125 15.3125C2.60723 15.3125 2.1875 14.8928 2.1875 14.375ZM6.25 14.375C6.25 14.0298 6.52982 13.75 6.875 13.75H16.875C17.2202 13.75 17.5 14.0298 17.5 14.375C17.5 14.7202 17.2202 15 16.875 15H6.875C6.52982 15 6.25 14.7202 6.25 14.375Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostIconNew);
export default __webpack_public_path__ + "static/media/post-Icon-new.d588f97eb2f40a403389609add30aa51.svg";
export { ForwardRef as ReactComponent };